import removeSpecialChars from "~/src/utils/remove-special-chars";
import { formatNumber } from "~/src/utils/functions";
import criptografiaSHA256 from "~/src/utils/criptografia-sha256";
import stringSanitize from "~/src/utils/string-sanitize";

const getEncrypted = (string, hasSanitize = true) => {
  if (hasSanitize) {
    return criptografiaSHA256(
      stringSanitize(string),
      process.env.VUE_APP_VIVO_SALT
    );
  }
  return criptografiaSHA256(string, process.env.VUE_APP_VIVO_SALT);
};

// eslint-disable-next-line no-unused-vars
const Types = {
  SET_PRODUCT: "SET_PRODUCT",
  SET_ORDER_PERSONAL_DATA: "SET_ORDER_PERSONAL_DATA",
  SET_MODALITY: "SET_MODALITY",
  SET_ORDER_ID: "SET_ORDER_ID",
  SET_ADDRESS: "SET_ADDRESS",
  SET_BILL: "SET_BILL",
  SET_EXPIREDATE: "SET_EXPIREDATE",
  SET_STATUS_ADDRESS: "SET_STATUS_ADDRESS",
  SET_DEPENDENTES: "SET_DEPENDENTES",
  SET_PRICE: "SET_PRICE",
  CLEAR_PERSONAL_DATA: "CLEAR_PERSONAL_DATA",
  SET_EXTERNAL_ERROR: "SET_EXTERNAL_ERROR",
  SET_ERROR_FORM: "SET_ERROR_FORM",
  SET_CONFIG_BILL_INFO: "SET_CONFIG_BILL_INFO",
  SET_ID_SESSION_OFDB: "SET_ID_SESSION_OFDB",
  SET_TYPE_LINE: "SET_TYPE_LINE",
};

export const state = {
  identificadorPedido: null,
  lead: {},
  valorTotal: 0,
  idSessionOFDB: null,
  produtos: {
    movel: {
      ddd: null,
      sku: "",
      modalidade: "",
    },
  },
  statusEndereco: false,
  endereco: {
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    localidade: "",
    uf: "",
    cidade: "",
    estado: "",
  },
  tipoLinha: "manterNumero",
  tipoFatura: "digital",
  diaVencimento: "17",
  dependentes: [],
  withExternalErrors: [],
  errorForm: null,
};

export const getters = {
  getTipoLinha: state => state.tipoLinha,
  getDdd: state => state.lead.telefone.replace(/\W/g, "").substr(0, 2),
  getSku: state => state.produtos.movel.sku,
  getProduct: state => state.produtos,
  getLead: state => state.lead,
  getUserObject: state => ({
    user: {
      name: state.lead.nome ? getEncrypted(state.lead.nome) : "",
      cpf: state.lead.cpf ? getEncrypted(state.lead.cpf) : "",
      email: state.lead.email ? getEncrypted(state.lead.email, false) : "",
      hasDevice: false,
      isLoggedin: false,
      currentPlanType: "",
      currentPlanValue: "",
      msisdn: state.lead.telefone ? getEncrypted(state.lead.telefone) : "",
      status: "pendente",
      type: "visitante",
      plans: [],
      address: {
        city: state.endereco.localidade
          ? stringSanitize(state.endereco.localidade)
          : "",
        state: state.endereco.uf ? stringSanitize(state.endereco.uf) : "",
        postalCode: state.endereco.cep ? getEncrypted(state.endereco.cep) : "",
        country: "BRA",
      },
    },
  }),
  getProductObject: (state, getters, rootState, rootGetters) => ({
    name: stringSanitize(rootGetters["catalog/getPlanName"]),
    id: rootGetters["catalog/getSelectedPlan"].info_plano.campanha,
    price: rootGetters["catalog/getPrice"].toFixed(2),
    originalPrice: rootGetters["catalog/getOriginalPrice"].toFixed(2),
    category: rootGetters["catalog/getCategory"],
    // variant: "[variacao]",
    quantity: 1,
    planFlowType:
      state.lead.modalidade === "NovaLinha" ? "alta" : "portabilidade",
    hasdevice: false,
    "apps-name": rootGetters["catalog/getAppsName"],
  }),
  getProductsTansaction: (state, getters, rootState, rootGetters) => {
    const productDefault = getters.getProductObject;
    const products = [];
    products.push(productDefault);
    state.dependentes.forEach(item => {
      products.push({
        ...productDefault,
        name: `dependente:${productDefault.name}`,
        category: `${productDefault.category}/dependente`,
        planFlowType: item.isNewLine ? "alta" : "portabilidade",
        price:
          products.length <= rootGetters["catalog/getDependentesRules"].gratis
            ? "0"
            : `${rootGetters["catalog/getDependentesRules"].valor}`,
        originalPrice: `${rootGetters["catalog/getDependentesRules"].valor}`,
      });
    });
    return products;
  },
  getOrderId: state => state.identificadorPedido,
  getTel: state => formatNumber(state.lead.telefone),
  getTelClean: state => state.lead.telefone,
  getAddress: state => state.endereco,
  getStatusAddress: state => state.statusEndereco,
  getTipoFatura: state => state.tipoFatura,
  getDiaVencimento: state => state.diaVencimento,
  getDependentesCount: state => state.dependentes.length,
  getDependentes: state => state.dependentes,
  getDependenteDefault: state => {
    return {
      isNewLine: true,
      cpf: state.lead.cpf,
      number: formatNumber(state.lead.telefone).substr(0, 4),
      dependenteValue: "Grátis",
    };
  },
  getPrice: state => state.valorTotal,
  getDependentesPrice: state =>
    state.dependentes.reduce((acc, curr) => {
      if (curr.dependenteValue === "Grátis") return acc + 0;
      return acc + curr.dependenteValue;
    }, 0),
  getErrorForm: state => state.errorForm,
  getDiasVencimento: state => state.billConfig.diaVencimento,
  getListBank: state => {
    const listBank = state.billConfig.bancosDA;

    const newListBank = listBank.map(bank => ({
      value: bank.codigo,
      text: bank.nome,
    }));

    return newListBank;
  },
  getIdSessionOFDB: state => state.idSessionOFDB,
};

export const mutations = {
  [Types.SET_PRODUCT]: (state, product) => {
    state.produtos.movel = product;
  },
  [Types.SET_ORDER_PERSONAL_DATA]: (state, lead) => {
    state.lead = { ...lead };
  },
  [Types.SET_MODALITY]: (state, modality) => {
    state.lead.modalidade = modality;
  },
  [Types.SET_ORDER_ID]: (state, orderId) => {
    state.identificadorPedido = orderId;
  },
  [Types.SET_ADDRESS]: (state, address) => {
    state.endereco = address;
  },
  [Types.SET_STATUS_ADDRESS]: (state, status) => {
    state.statusEndereco = status;
  },
  [Types.SET_BILL]: (state, tipoFatura) => {
    state.tipoFatura = tipoFatura;
  },
  [Types.SET_EXPIREDATE]: (state, diaVencimento) => {
    state.diaVencimento = diaVencimento;
  },
  [Types.SET_DEPENDENTES]: (state, dependentes) => {
    state.dependentes = [...dependentes];
  },
  [Types.SET_PRICE]: (state, valorTotal) => {
    state.valorTotal = valorTotal;
  },
  [Types.SET_TYPE_LINE]: (state, typeLine) => {
    state.tipoLinha = typeLine;
  },
  [Types.CLEAR_PERSONAL_DATA]: state => {
    state.lead = {};
    state.endereco = {
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      localidade: "",
      uf: "",
      cidade: "",
      estado: "",
    };
    state.statusEndereco = false;
    state.dependentes = [];
    state.withExternalErrors = [];
  },
  [Types.SET_EXTERNAL_ERROR]: (state, externalError) => {
    state.withExternalErrors = [...state.withExternalErrors, externalError];
  },
  [Types.SET_ERROR_FORM]: (state, errorMessage) => {
    state.errorForm = errorMessage;
  },
  [Types.SET_CONFIG_BILL_INFO]: (state, configs) => {
    state.billConfig = configs;
  },
  [Types.SET_ID_SESSION_OFDB]: (state, idOFDB) => {
    state.idSessionOFDB = idOFDB;
  },
};

export const actions = {
  setProduct: ({ commit }, order) => {
    commit(Types.SET_PRODUCT, order);
  },
  setPersonalData: ({ commit, rootGetters }, lead) => {
    let { cpf, email, telefone } = lead;
    telefone = removeSpecialChars(telefone);
    cpf = removeSpecialChars(cpf);
    let {
      dadosAdicionais: { cidade, uf, ddd },
    } = rootGetters.getQuery;
    commit(Types.SET_ORDER_PERSONAL_DATA, {
      ...lead,
      email,
      telefone,
      cpf,
      cidade,
      uf,
      ddd: Number(ddd),
    });
  },
  setModality: ({ commit }, modality) => commit(Types.SET_MODALITY, modality),
  setOrderId: ({ commit }, orderId) => commit(Types.SET_ORDER_ID, orderId),
  setAddress: ({ commit }, endereco) => {
    commit(Types.SET_ADDRESS, endereco);
    commit(Types.SET_STATUS_ADDRESS, true);
  },
  setAddressAndBill: (
    { commit, rootState },
    { endereco, tipoFatura, diaVencimento }
  ) => {
    const isAnualPlan =
      rootState.catalog.selectedPlan.info_plano.anual.toLowerCase() === "true";

    if (isAnualPlan) commit(Types.SET_BILL, "digital");
    else commit(Types.SET_BILL, tipoFatura);

    commit(Types.SET_EXPIREDATE, diaVencimento);
    commit(Types.SET_ADDRESS, endereco);
    if (endereco.logradouro !== "") commit(Types.SET_STATUS_ADDRESS, true);
    else commit(Types.SET_STATUS_ADDRESS, false);
  },
  setDependentes: ({ commit }, dependentes) =>
    commit(Types.SET_DEPENDENTES, dependentes),
  addPrice: ({ commit, state }, value) => {
    const newTotal = state.valorTotal + value;
    commit(Types.SET_PRICE, newTotal);
  },
  subPrice: ({ commit, state }, value) => {
    const newTotal = state.valorTotal - value;
    commit(Types.SET_PRICE, newTotal);
  },
  setDiaVencimento: ({ commit }, diaVencimento) =>
    commit(Types.SET_EXPIREDATE, diaVencimento),
  clearData: ({ commit }) => commit(Types.CLEAR_PERSONAL_DATA),
  clearDataAll: () => window.sessionStorage.clear(),
  setExternalError: ({ commit }, externalError) =>
    commit(Types.SET_EXTERNAL_ERROR, externalError),
  setBill: ({ commit }, bill) => commit(Types.SET_BILL, bill),
  setErrorForm: ({ commit }, errorMessage) =>
    commit(Types.SET_ERROR_FORM, errorMessage),
  setBillConfig: ({ commit }, payload) => {
    commit(Types.SET_CONFIG_BILL_INFO, payload);
  },
  setIdSessionOFDB: ({ commit }, payload) => {
    commit(Types.SET_ID_SESSION_OFDB, payload);
  },
};
